import { getApiClient } from './client';
import type { TenantConfig } from '../types/tenant';

export async function getTenantConfig(tenant: string): Promise<TenantConfig> {
  const client = getApiClient(tenant);
  return client.get<TenantConfig>('/tenant/config');
}

export async function updateTenantCustomization(
  tenant: string,
  customization: { dashboardLabel?: string; coachDmHighlightColor?: string }
): Promise<TenantConfig> {
  const client = getApiClient(tenant);
  return client.put<TenantConfig>('/tenant/customization', { customization });
}
